import { createOptionsFrom } from "@/lib/common/Option";
import { z } from "zod";

export const PriceSourceLabels = {
	TcgPlayerMarket: "TCGplayer Market Price",
	TcgPlayerLow: "TCGplayer Low Price",
	TcgPlayerRecent: "TCGplayer Recent Price"
};

export type PriceSource = keyof typeof PriceSourceLabels;

export const PriceSourceOptions = createOptionsFrom(PriceSourceLabels);

export const PriceSourceSchema = z.enum(
	Object.keys(PriceSourceLabels) as PriceSource[]
);
